<template>
    <div>
        <b-modal size="sm" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-spinner v-if="loading" label="Carregando..." class="my-3 d-block mx-auto"></b-spinner>
            <b-form v-if="!loading" @submit.prevent="save">

                <b-card>
                    <b-form-row>
                        <LgFinderPageUnidadeAdministrativa id="departamentoMonitoramentoForm"
                            :prefix="prefix + title + ' > '" v-model="form.departamento" label="Departamento:*" required
                            @onselect="handleSelectUnidadeAdministrativa" />
                    </b-form-row>

                    <b-form-row>
                        <LgFinderPageLocalArmazenamento id="localMonitoramentoForm" :departamento="form.departamento"
                            :disabled="!form.departamento || !form.departamento.id" :prefix="prefix + title + ' > '"
                            v-model="form.local" label="Local Armazenamento:" required @input="handleLocal" />
                    </b-form-row>


                    <b-form-row>
                        <LgFinderPageLeitor :showSelect="true" @closeMultiplo="handleMultiplos"
                            :podeClicarNaAntenaParaSelecionar="true" id="leitorMonitoramentoForm"
                            :prefix="prefix + title + ' > '" v-model="form.leitor" label="Leitor:*" required
                            @close="handleLeitor" />


                        <b-form-group label="Antena:*" style="margin-top: 4px;">

                            {{ form.leitor.antena.index + (form.leitor.antena.descricao ? (" - " + form.leitor.antena.descricao) : "")  }}
                        </b-form-group>

                    </b-form-row>



                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-card>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import LgFinderPageLeitor from "@/components/Finders/LgFinderPageLeitor.vue";

export default {
    components: {
        LgFinderPageLocalArmazenamento,
        LgFinderPageLeitor,
        LgFinderPageUnidadeAdministrativa,
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {
            departamento: { id: { required } },
            leitor: { id: { required } },
        },
    },
    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loading: false,
            form: {
                departamento: {},
                leitor: { antena: { index: "" } },
                local: {},
                leitores: []
            },
            showModal: true,
            title: "Cadastro",


        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/leitor-monitoramento`);
    },
    async mounted() {
        if (this.id) {
            this.loading = true;
            const { data } = await this.$service.findById(this.id);
            this.form = data;
            this.loading = false;
        }
    },
    methods: {
        handleMultiplos(leitores) {
            this.form.leitores = leitores;
            this.form.leitor = { id: 0, nome: 'Vários', antena: { index: "" } }

        },
        handleLeitor(leitor) {
            if (leitor && leitor.id)
                this.form.leitor = leitor;
            else
                this.form.leitor = { antena: { index: "" } }

            this.form.leitores = [];
        },
        handleLocal(local) {
            this.form.local = local;
        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
        },
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }

            try {
                await this.$saveResource(this.form, "", true, {}, false, true);
                this.cancelar();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
        },

        cancelar() {
            this.$emit("close");
        },

    },
};
</script>
